import ImageResizeModule from './quillImageResizeModule'

export const TOOLTIPS_TOOLBAR: Record<string, string> = {
  '.ql-size .ql-picker-label': 'Tamanho do texto',
  '.ql-size .ql-picker-item[data-value="small"]': 'Pequeno',
  '.ql-size .ql-picker-item:not([data-value])': 'Normal',
  '.ql-size .ql-picker-item[data-value="large"]': 'Grande',
  '.ql-size .ql-picker-item[data-value="huge"]': 'Enorme',
  'button.ql-bold': 'Negrito',
  'button.ql-italic': 'Itálico',
  'button.ql-underline': 'Sublinhado',
  '.ql-align .ql-picker-label': 'Alinhamento',
  '.ql-align .ql-picker-item:not([data-value])': 'Alinhar à esquerda',
  '.ql-align .ql-picker-item[data-value="center"]': 'Centralizar',
  '.ql-align .ql-picker-item[data-value="right"]': 'Alinhar à direita',
  '.ql-align .ql-picker-item[data-value="justify"]': 'Justificar',
  'button.ql-indent[value="-1"]': 'Diminuir recuo',
  'button.ql-indent[value="+1"]': 'Aumentar recuo',
  'button.ql-list[value="ordered"]': 'Lista numerada',
  'button.ql-list[value="bullet"]': 'Lista com marcadores',
  '.ql-color .ql-picker-label': 'Cor do texto',
  '.ql-background .ql-picker-label': 'Cor de fundo',
  'button.ql-link': 'Inserir link',
  'button.ql-image': 'Inserir imagem',
  'button.ql-clean': 'Limpar formatação',
}

export const LOGO_PLACEHOLDER = 'data:image/svg+xml;utf8,'
  + '<svg xmlns=\'http://www.w3.org/2000/svg\' width=\'100\' height=\'100\'>'
  + '<rect width=\'100\' height=\'100\' fill=\'%23e0e0e0\'/>'
  + '<text x=\'50\' y=\'55\' font-size=\'14\' text-anchor=\'middle\' fill=\'%23999\'>Logo</text>'
  + '</svg>'

export const EDITOR_TOOLBAR = [
  [{ size: ['small', false, 'large', 'huge'] }],
  ['bold', 'italic', 'underline'],
  [{ align: [] }],
  [{ indent: '-1' }, { indent: '+1' }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ color: [] }, { background: [] }],
  ['link', 'image'],
  ['clean'],
]

export const CUSTOM_MODULES = [{ alias: 'imageResize', module: ImageResizeModule }]
export const EDITOR_OPTIONS = { modules: { imageResize: {} } }
